<template>
  <ModuleWrapper
    :moduleId="moduleId"
    :image="imageSrcPath('assets/branding/sidebar.svg')"
    title="Sidebar Overlay"
    @initializeData="initializeData"
  >
    <template #main>
      <StudioSelect
        id="overlay-type"
        label="Overlay Type"
        :options="[
          { value: 'dark', label: 'Dark' },
          { value: 'light', label: 'Light' }
        ]"
        size="small"
        orientation="horizontal"
        class="tw-mb-2"
        :value="selectedOverlayType"
        @change="e => onSelectOverlayType(e.target.value)"
      />

      <div class="tw-flex tw-items-center tw-justify-between">
        <label for="opacitySlider" class="tw-block tw-text-xs"> Opacity </label>
        <div class="tw-flex tw-w-[300px] tw-items-center tw-gap-3">
          <span class="tw-text-sm">0</span>
          <Slider id="opacitySlider" :max="100" :min="0" :value="sidebarOpacityValue" @change="setSidebarOpacity" />
          <span class="tw-text-sm">100</span>
        </div>
      </div>

      <div class="tw-flex tw-items-center tw-justify-between">
        <label for="blurSlider" class="tw-block tw-text-xs"> Blur </label>
        <div class="tw-flex tw-w-[300px] tw-items-center tw-gap-3">
          <span class="tw-text-sm">0</span>
          <Slider id="blurSlider" :max="100" :min="0" :value="sidebarBlurValue" @change="setSidebarBlur" />
          <span class="tw-text-sm">100</span>
        </div>
      </div>
    </template>
  </ModuleWrapper>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';

import ModuleWrapper from './ModuleWrapper.vue';

import { Slider } from '@/commonComponents';
import { StudioSelect } from '@/studioComponents';

export default {
  name: 'SidebarColor',
  components: {
    ModuleWrapper,
    StudioSelect,
    Slider
  },
  props: {
    moduleId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectedOverlayType: 'dark',
      sidebarOpacityValue: 50,
      sidebarBlurValue: 50
    };
  },
  mounted() {
    this.initializeData();
  },
  computed: {
    ...mapGetters('branding', {
      getInitialModuleData: 'getInitialModuleData'
    })
  },
  methods: {
    ...mapMutations('branding', {
      setChangesMadeInThemeObj: 'setChangesMadeInThemeObj'
    }),
    initializeData() {
      const moduleKeys = ['primary_background_shade', 'alt_primary_background_shade', 'sidebar_alpha', 'sidebar_blur'];
      const { sidebar_alpha, primary_background_shade, sidebar_blur, alt_primary_background_shade } =
        this.getInitialModuleData(moduleKeys);
      this.sidebarBlurValue = sidebar_blur ? +sidebar_blur.split('px')[0] / 2 : 50;
      this.sidebarOpacityValue = sidebar_alpha ? sidebar_alpha * 100 : 50;
      this.selectedOverlayType = this.getSidebarOverlayType(primary_background_shade, alt_primary_background_shade);
    },
    getSidebarOverlayType(primaryShade, altPrimaryShade) {
      if (primaryShade === '0, 0, 0' && altPrimaryShade === '255, 255, 255') {
        return 'dark';
      }
      return 'light';
    },
    onSelectOverlayType(selectedType) {
      this.selectedOverlayType = selectedType;
      if (selectedType === 'dark') {
        this.setChangesMadeInThemeObj({
          primary_background_shade: '0, 0, 0',
          alt_primary_background_shade: '255, 255, 255'
        });
      } else {
        this.setChangesMadeInThemeObj({
          primary_background_shade: '255, 255, 255',
          alt_primary_background_shade: '0, 0, 0'
        });
      }
    },
    setSidebarOpacity(event) {
      let selectedOpacity = Math.round(Number(event.target.value));

      this.sidebarOpacityValue = selectedOpacity || 0.001;
      selectedOpacity = selectedOpacity || 0.001;

      const pageItemAlpha = (selectedOpacity / 100) * 0.7;

      this.setChangesMadeInThemeObj({
        sidebar_alpha: selectedOpacity / 100,
        page_item_alpha: parseFloat(pageItemAlpha.toFixed(3))
      });
    },
    setSidebarBlur(event) {
      let selectedBlurValue = Math.round(Number(event.target.value));

      this.sidebarBlurValue = selectedBlurValue || 0.001;
      selectedBlurValue = selectedBlurValue || 0.001;
      this.setChangesMadeInThemeObj({
        sidebar_blur: `${selectedBlurValue * 2}px`
      });
    }
  }
};
</script>
